// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import { castToString } from 'helpers/reduxFormFunctions'
import { convertDDtoDMSPref } from 'helpers/coordsConversion'
import { createMetersAndFeetString } from 'helpers/unitConversion'

// s is a segment end however it's stripped down to only the important fields for callsign cascade.
// This is why we aren't reusing another of the exiting site/segmentEnd formatters.

const cleanCallsignCascadeSegmentEndData = (s, withinBulkEdit = false) => {
  const {
    segmentEndId,
    siteName,
  } = s

  const asr = castToString(s.asr)
  const callSign = castToString(s.callSign)
  const groundElevation = createMetersAndFeetString(s.groundElevation)
  const latitude = convertDDtoDMSPref(s.latitude, 'latitude')
  const longitude = convertDDtoDMSPref(s.longitude, 'longitude')
  const serviceContactCode = castToString(s.serviceContactCode)

  // if we're in bulk edit, and we're the aggregate segment end,
  // we don't show these values because they could be one-to-many
  const band = withinBulkEdit ? '' : castToString(s.band)
  const rcnNumber = withinBulkEdit ? '' : castToString(s.rcnNumber)
  const segmentStatusAbbreviation = withinBulkEdit ? '' : castToString(s.segmentStatusAbbreviation)

  return {
    asr,
    band,
    callSign,
    groundElevation,
    latitude,
    longitude,
    rcnNumber,
    segmentEndId,
    serviceContactCode,
    siteName,
    segmentStatusAbbreviation,
  }
}

export default cleanCallsignCascadeSegmentEndData
